import React from 'react';
import SEO from '../components/SEO/SEO';
import HeroBanner from '../components/HeroBanner/HeroBanner';
import QuoteFrom from '../components/QuoteFrom/QuoteFrom';
import Stories from '../components/Stories/Stories';
import WhatWeDo from '../components/WhatWeDo/WhatWeDo';
import Benefits from '../components/Benefits/Benefits';
import PersonalHomePageCharts from '../components/HomePageCharts/PersonalHomePageCharts';
import Button from '../components/Button/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Link } from 'gatsby';
import PartnershipAd from '../components/PartnershipAd/PartnershipAd';
const tech = require('../assets/icons/tech-partner.svg');
const health = require('../assets/icons/health-partner.svg');
const traffic = require('../assets/icons/traffic-partner.svg');

const PartnershipsPage = () => (
	<React.Fragment>
		<SEO
			title='Partnerships'
			description='An innovative healthcare platform which allows businesses to get their employees ‘back to work’ faster. Reducing sick days and improving employee wellness is a caring way to boost business performance and productivity.'
		/>
		<HeroBanner
			backgroundStyle={{ backgroundPosition: 'top' }}
			imageSrc='meeting.jpg'
			imageAlt='Meeting with 4 people'
			title='Partnerships'
			tagline='Teaming up to offer enhanced health products that will make a difference to your users.'
		/>
		<WhatWeDo
			title='How we can partner'
			subtitle="We are passionate about developing health technologies that solve problems, add value and increase efficiency, so let's talk and team up if the fit is right."
			hideBrochure={true}
			/* set singlePage = true if number of items to display <= 4 */
			singlePage={true}
			contentItems={[
				{
					imageSrc: tech,
					title: 'Tech Partnership',
					text: 'Enhance and integrate secure technologies to help your end consumers',
				},
				{
					imageSrc: health,
					title: 'Health Partnership',
					text: 'Access Hi-tech solutions to increase reach and add value services',
				},
				{
					imageSrc: traffic,
					title: 'Traffic Partnership',
					text: 'Enhance your products with tailored health tools',
				},
			]}
		/>
		<PartnershipAd
			imageTitle='For Tech Partners'
			contentBody={<TechPartners />}
			imageAlt='Tech'
			imageSrc='tech-partner.svg'
			side={'right'}
		/>
		<PartnershipAd
			imageTitle='For Health Partners'
			contentBody={<HealthPartners />}
			imageAlt='health'
			imageSrc='health-partner.svg'
			side={'right'}
			footer={
				<PartnerFooter
					target='GP surgery, pharmacy, private clinic or a travel clinic'
					link='https://landing.dochq.co.uk/gp_practices-4/'
				/>
			}
		/>
		<PartnershipAd
			imageTitle='For Traffic Partners'
			contentBody={<TrafficPartners />}
			imageAlt='Traffic'
			imageSrc='traffic-partner.svg'
			side={'right'}
			footer={
				<PartnerFooter
					target='travel blogger or a travel magazine'
					link='https://landing.dochq.co.uk/affiliate_bloggers-3/'
				/>
			}
		/>
		<CallUs />
		<Partners
			logoList={[
				'shieldwear.svg',
				'delfin.svg',
				'synlab.svg',
				'citydoc.svg',
				'unilabs.svg',
				'symbiotics.svg',
			]}
			title='Our Partners'
		/>
		<QuoteFrom
			authorName='Dermot Mullins'
			authorRole='Managing Director'
			authorCompany='Ingenieur Ltd'
			authorImageSrc='dermot.png'
			quote={[
				'This is a low cost, effective solution to enable my staff to take control of their health and time. It also benefits the business through reducing absenteeism and increasing productivity.',
			]}
			backgroundColor='var(--doc-light-grey)'
		/>
	</React.Fragment>
);

const TechPartners = () => (
	<React.Fragment>
		<h5 style={{ fontWeight: 'normal', marginTop: '0px' }}>
			We work within the insurance and employee benefit sectors to create value added health
			products which support their consumers.
		</h5>
		<ul className='shwd-list'>
			<li>Enhance and combine technologies safely with bespoke health services</li>
			<li>Share data, AI tools and analytics to create powerful health insights</li>
			<li>Integrate health tools for your consumers</li>
		</ul>
	</React.Fragment>
);
const HealthPartners = () => (
	<React.Fragment>
		<h5 style={{ fontWeight: 'normal', marginTop: '0px' }}>
			We offer a global health network to support people whether they are at work, home or
			travelling.
		</h5>
		<ul className='shwd-list'>
			<li>
				Join our network of regulated and accredited health suppliers ranging from laboratories and
				clinics to medical professionals and pharmacies.
			</li>
			<li>Enhance patient information with reliable and accurate health tools</li>
			<li>Access Hi-tech knowledge and support to manage your patients securely</li>
		</ul>
	</React.Fragment>
);
const TrafficPartners = () => (
	<React.Fragment>
		<h5 style={{ fontWeight: 'normal', marginTop: '0px' }}>
			We create unique health tech solutions supported by medical knowledge and advice.
		</h5>
		<ul className='shwd-list'>
			<li>Expand your travel products with tailored health tools</li>
			<li>
				Keep your readers informed and engaged with reliable and accurate health information and
				tech solutions
			</li>
			<li>Monetise your traffic through our affiliate scheme trusted tracking system</li>
		</ul>
	</React.Fragment>
);
const PartnerFooter = ({ link, target }) => (
	<React.Fragment>
		<h5 style={{ fontWeight: 'normal' }}>
			If you are a {target}{' '}
			<a
				target='_blank'
				rel='noopener noreferrer'
				style={{ color: 'var(--doc-green)' }}
				href={link}
			>
				click here
			</a>{' '}
			to know more.
		</h5>
	</React.Fragment>
);
const CallUs = () => (
	<React.Fragment>
		<div
			className='row'
			style={{
				minHeight: '120px',
				backgroundColor: 'var(--doc-light-grey)',
				justifyContent: 'center',
				alignContent: 'center',
			}}
		>
			<Link to='/contact-us'>
				<button style={{ margin: '20px' }} type='button' role='button' class='btn btn-swu-pink'>
					Write to Us
				</button>
			</Link>{' '}
			<p style={{ maxWidth: '90%', display: 'flex', alignItems: 'center' }}>
				{' '}
				or call us on 0330 880645 and we can get you started
			</p>
		</div>
	</React.Fragment>
);
const Partners = ({ logoList, title }) => {
	const logos = logoList.map(image => {
		return (
			<img
				key={image}
				src={require(`../assets/icons/${image}`)}
				alt='partner logo'
				className='col-sm-12 col-md-12 col-lg-2'
				style={{ maxHeight: '70px', paddingBottom: '5px' }}
			/>
		);
	});

	return (
		<React.Fragment>
			<div style={{ minHeight: '180px', padding: '20px' }}>
				<div
					className='row'
					style={{
						justifyContent: 'center',
						paddingTop: '15px',
						alignContent: 'center',
					}}
				>
					<h2>{title}</h2>
				</div>
				<div
					className='row'
					style={{
						margin: 'auto',
						maxWidth: '90%',
						paddingTop: '20px',
						paddingBottom: '35px',
					}}
				>
					{logos}
				</div>
			</div>
		</React.Fragment>
	);
};

export default PartnershipsPage;
